import { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { ApiSaveEnum } from "app/constants/apiConst";
import { ErrorCodeErrorDTO } from "@generated/v2";
import { useInstanceValue } from "app/hooks/useInstanceValue";

function usePutData<T, P = void>(
  call: (...params) => Promise<AxiosResponse<T>>
) {
  const [body, setBody] = useState<P>();
  const [data, setData] = useState<T>();
  const [errorData, setErrorData] = useState<ErrorCodeErrorDTO[]>();
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const saveDataRef = useInstanceValue(async () => {
    try {
      setLoading(true);
      setIsSuccess(false);
      setIsError(false);

      const response = await call(body, { type: ApiSaveEnum.PUT });
      setData(response.data);
      setIsSuccess(true);
    } catch (error: any) {
      setErrorData(error?.response?.data);
      setIsError(true);
    } finally {
      setLoading(false);
      setBody(undefined);
    }
  });

  useEffect(() => {
    body && saveDataRef.current();
  }, [body, saveDataRef]);

  return { body, data, errorData, loading, isError, isSuccess, setBody };
}

export default usePutData;
